import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="16"
        viewBox="0 0 16 16"
        width="16"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM8.75 11.75C8.75 12.1642 8.41421 12.5 8 12.5C7.58579 12.5 7.25 12.1642 7.25 11.75C7.25 11.3358 7.58579 11 8 11C8.41421 11 8.75 11.3358 8.75 11.75ZM8 3.875C6.55025 3.875 5.375 5.05025 5.375 6.5H6.625C6.625 5.74061 7.24061 5.125 8 5.125H8.25C8.87132 5.125 9.375 5.62868 9.375 6.25C9.375 6.87132 8.87132 7.375 8.25 7.375H8C7.65482 7.375 7.375 7.65482 7.375 8V9.5C7.375 9.84518 7.65482 10.125 8 10.125C8.34518 10.125 8.625 9.84518 8.625 9.5V8.59556C9.75849 8.41577 10.625 7.43408 10.625 6.25C10.625 4.93832 9.56168 3.875 8.25 3.875H8Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
